<template>
  <div>
    <base-header class="pb-6">
    </base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Pesos a Servir </h3>
            </div>
            <div class="col-6 text-right">
              <el-tooltip content="Delete" placement="top">
                <base-button type="danger" icon size="sm" @click="saveCockedPortions">
                  <span class="btn-inner--icon"><i class="fas fa-save"></i></span>
                  <span class="btn-inner--text">Guardar</span>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="row starter-page">
          <div class="container-fluid ">
            <el-table class="table-responsive table-flush"
                      header-row-class-name="thead-light"
                      row-key="id"
                      :data="meals_ordered"
                      :row-class-name="rowClassName"
                      @selection-change="onSelectionChange">
              <el-table-column label="Alimento"
                               min-width="220px"
                               prop="meal_id"
                               sortable>
                <template v-slot="{row}">
                  <div class="table-user">
                    {{ meals[row.meal_id].name.toUpperCase()}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Sugrupo"
                               prop="subgroup_id"
                               width="130px"
                               min-width="90px"
                               sortable>
                <template v-slot="{row}">
                  <div class="table-user">
                    <b>
                      {{ subgroups[row.subgroup_id]['name'].toUpperCase()}}
                    </b>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="P. crudo"
                               prop="peso_acumulado"
                               width="130px"
                               min-width="90px"
                               sortable>
                <template v-slot="{row}">
                  <div class="table-user">
                    {{ row.peso_acumulado}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="P.cocido"
                               prop="subgroup_id"
                               width="130px"
                               min-width="90px"
                               sortable>
                <template v-slot="{row}">
                  <base-input type="number" placeholder="23" id="example-number-input"
                              class="noMargin"
                              v-model="meals_ordered_var[row.subgroup_id].peso_acumulado"/>
                </template>
              </el-table-column>

              <el-table-column label="800"
                               prop="peso_acumulado"
                               width="130px"
                               min-width="100px"
                               sortable>
                <template v-slot="{row}">
                  <div class="table-user">
    <span v-if="row.detalles[0]">
    {{ Math.round(row.detalles[0].peso_subgrupo*meals_ordered_var[row.subgroup_id].peso_acumulado/row.peso_acumulado*100)/100}}
    </span>
                  </div>
                </template>
              </el-table-column>


              <el-table-column label="600"
                               prop="peso_acumulado"
                               width="130px"
                               min-width="100px"
                               sortable>
                <template v-slot="{row}">
                  <div class="table-user">
    <span v-if="row.detalles[1]">

    {{ Math.round(row.detalles[1].peso_subgrupo*meals_ordered_var[row.subgroup_id].peso_acumulado/row.peso_acumulado*100)/100}}
    </span>

                  </div>
                </template>
              </el-table-column>


              <el-table-column label="400"
                               prop="peso_acumulado"
                               width="130px"
                               min-width="100px"
                               sortable>
                <template v-slot="{row}">
                  <div class="table-user">
    <span v-if="row.detalles[2]">

   {{ Math.round(row.detalles[2].peso_subgrupo*meals_ordered_var[row.subgroup_id].peso_acumulado/row.peso_acumulado*100)/100}}
    </span>

                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import moment from "moment";
  import {format, subDays, addDays} from "date-fns";

  import users from './users'
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';
  // import BaseTable from '@/components/BaseTable';
  import {Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip} from 'element-ui'

  export default {
    name: 'starter-page',
    components: {
      StatsCard,
      RouteBreadCrumb,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        users,
        user: [],
        currentPage: 1,
        selectedRows: [],
        date: new Date().toISOString().substr(0, 10),
        // date:"2019-07-30",
        subgroups: [],
        totalIngredients: [],
        ingredientsByMeal: [],
        meals: [],
        meals_ordered: [],
        meals_ordered_var: [],

        ingredients: [],
      };
    },
    created() {
      this.getIngredientsByMeal();
    },
    methods: {
      onSelectionChange(selectedRows) {
        this.selectedRows = selectedRows
      },
      rowClassName({rowIndex}) {
        if (rowIndex === 0) {
          return 'table-success'
        } else if (rowIndex === 2) {
          return 'table-warning'
        }
        return ''
      },
      saveCockedPortions() {
        axios.post('subgroup/catering/meal/' + this.date, {
          meals_ordered: this.meals_ordered,
          meals_ordered_var: this.meals_ordered_var
        }).then(response => {
          console.log('guardado con exito')
        }).catch((error) => {
          console.log(error)
        })
      },
      getIngredientsByMeal($date = null) {
        axios.get('subgroup/catering/meal/' + this.date)
          .then((resp) => {
            this.meals = resp.data.meals;
            this.meals_ordered = resp.data.meals_ordered;
            let temp = resp.data.meals_cocked;
            if (Object.keys(temp).length > 0) {
              this.meals_ordered_var = resp.data.meals_cocked;
            } else {
              this.meals_ordered_var = resp.data.meals_ordered_var;
            }
            this.subgroups = resp.data.subgroup;
          }).catch(err => console.log(err))
      },
    }
  };
</script>
<style>
  .noMargin {
    margin-bottom: 0rem;
  }

  .starter-page {
    min-height: calc(100vh - 380px);
  }
</style>
